import { useState } from "react";

export default function ShareButton({ title }: { title: string }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
    } catch {
      const input = document.createElement("input");
      input.value = window.location.href;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="relative">
      <button
        type="button"
        onClick={handleCopy}
        title={`复制《${title}》页面链接`}
        className="flex items-center gap-2 px-4 h-10 rounded-md border border-background-300 text-foreground-700 text-sm font-medium hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
      >
        <i className="ri-share-forward-line" />
        分享
      </button>
      {copied && (
        <span className="absolute -top-10 left-1/2 -translate-x-1/2 px-3 py-1.5 rounded-md bg-foreground-900 text-background-50 text-xs whitespace-nowrap animate-fade-in">
          链接已复制
        </span>
      )}
    </div>
  );
}